import ProjectAttributeModal from './ProjectAttributeModal'

export default ProjectAttributeModal
